import * as services from './generated/api';

export const useExperienceApi = () => services;
